import { gql } from '@apollo/client'

const ME_RAW = `
  mutation ME {
    me {
      ... on User {
        permissions
        releaseType
        lastActivity
        area
        createdAt

        company {
          id
          name
          contractBegin
          contractEnd
          allowedEmailDomains

          companyType {
            id
            name
          }

          contract {
            maxJobs
            maxReports
          }

          usersCount {
            admins
            editors
            viewers
            billable
          }

          # plan has the default values
          plan {
            name
            hasWinninReports
            savedPostSearches
            jobs
            editors
            viewers
            workspaces
            languages
            isActive
            workspaceChannels
            providers
            jobPinnedCreators
            jobPinnedPosts
            jobPinnedSubtopics
            jobPinnedTopics
            jobPinnedSavedSearches
            jobFolders
            jobPins
            workspaceZaiReports
            workspaceBrandCompetitors
          }

          # companyPlan has the addon values
          companyPlan {
            companyId
            hasWinninReports
            savedPostSearches
            jobs
            editors
            viewers
            languages
            workspaces
            isActive
            endDate
            workspaceChannels
            providers
            jobPinnedCreators
            jobPinnedPosts
            jobPinnedSubtopics
            jobPinnedTopics
            jobPinnedSavedSearches
            jobFolders
            jobPins
            workspaceZaiReports
            workspaceBrandCompetitors
          }
        }

        brands {
          name
          thumbnail
          id
          companyId
          status

          panels {
            id
            brandId
            title
            youtubeChannelThumbnail
            youtubeChannelId
            youtubeChannelName
            youtubeRefreshTokenStatus
            audienceRecommendationStatus
          }

          category {
            id
            country
            name
          }
        }

        email
        id
        name
        onboarding
        phone
        role
        thumbnail
        firstName
        lastName
        country
        jobTitle

        jobTitleType {
          id
          name
        }

        status
        facebookId

        terms {
          acceptedLastTerms
          lastAcceptedVersion
          lastAcceptTimestamp
        }

        attributes {
          hubspot {
            key
            value
          }
        }
      }

      ... on StatusMessage {
        success
        code
        title
        message
      }
    }
  }
`

const ME = gql`
  ${ME_RAW}
`

export { ME, ME_RAW }
